<template>
    <div>
        <b-button
            v-if="!loading"
            variant="outline-primary"
            @click="generateData"
        >
            <span>
                <strong class="d-flex">
                    <i class="icon icon-share" />
                    <span class="ml-2">{{ $t('custom.excel.button') }}</span>
                </strong>
            </span>
        </b-button>

        <b-spinner
            v-else
            variant="primary"
            class="align-middle"
            small
        />
    </div>
</template>

<script>
import { date } from '@/mixins/date';

export default {
    name: 'CustomExcel',
    props: {
        src: {
            type: String,
            'default': '',
        },

        data: {
            type: Array,
            'default': function() {
                return null;
            },
        },

        fields: {
            type: Object,
            'default': {},
        },

        routing: {
            type: Boolean,
            'default': true,
        },

        name: {
            type: String,
            'default': 'Список',
        },

        nameVersion: {
            type: Boolean,
            'default': false,
        },
    },

    mixins: [date],
    data() {
        return {
            loading: false,
        };
    },

    computed: {
        nameFile: function() {
            return this.name +
                    (this.nameVersion ? '_' + this.getDateTimeFormat() : '') +
                    '.xls';
        },
    },

    methods: {
        generateData: function() {
            this.loading = true;
            const params = this.routing ? { params: this.$route.query } : {};
            params.responseType = 'blob';
            return this.axios.get(this.src, params)
                .then((response) => {
                    this.loading = false;
                    const disposition = response.request.getResponseHeader('content-disposition');
                    const matches = /"([^"]*)"/.exec(disposition);
                    const filename = (matches != null && matches[1] ? matches[1] : 'file.csv');
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(response.data);
                    link.download = filename;

                    document.body.appendChild(link);

                    link.click();

                    document.body.removeChild(link);
                });
        },
    },
};
</script>